// src/App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Subscription from './components/Subscription';
import ProtectedRoute from './components/ProtectedRoute';
import Chat from './components/Chat';
import ShareView from './components/ShareView';
import ThankYou from './components/ThankYou';
import config from './config';

const App = () => {
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      // Public share pages must not bounce a stale login token to /login.
      if (window.location.pathname.startsWith('/s/')) return;

      const token = localStorage.getItem('accessToken');
      const tokenType = localStorage.getItem('tokenType');
      
      if (!token) return;

      try {
        const response = await fetch(`${config.apiUrl}/subscription/status`, {
          headers: {
            'Authorization': `${tokenType} ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);
        } else if (response.status === 401) {
          // Clear auth data if token is invalid
          localStorage.clear();
          window.location.href = '/login';
        }
      } catch (error) {
        console.error('Error checking subscription status:', error);
      }
    };

    checkSubscriptionStatus();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/s/:token" element={<ShareView />} />
        <Route path="/s" element={<ShareView />} />
        <Route path="/c/:uuid?" element={<Chat />} />
        <Route path="/c" element={<Chat />} />
        {/* One shell, three surfaces (nav rework 2026-07-27): /team and /p/:id
            render INSIDE <Chat/>, which derives the surface from the pathname
            and swaps only its centre column. The sidebar and the top bar stay
            mounted, so neither page is a stranded island any more. Both still
            guard themselves Chat-style (self-redirect to /login on 401). */}
        <Route path="/team/*" element={<Chat />} />
        <Route path="/team" element={<Chat />} />
        <Route path="/p/:id" element={<Chat />} />
        <Route path="/" element={<Navigate to="/c" replace />} />
        <Route path="/subscription" element={
          <ProtectedRoute allowedStatuses={[
            'PENDING', 'pending',
            'VERIFIED', 'verified',
            'INACTIVE', 'inactive',
            'LITE', 'lite',
            'LIMITED', 'limited',
            'EXPIRED', 'expired'
          ]}>
            <Subscription />
          </ProtectedRoute>
        } />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;